export default __webpack_public_path__ + "static/media/planet.3c24f446.webp";